import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import setting from "@/setting";

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },

  {
    path: '/chatAI',
    name: 'deepseek',
    component: () => import('@/components/deepspeak/index.vue')
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/views/route/index.vue'),
    redirect: '/guide',
    meta: {
      title: '维权资讯'
    },
    children: [{
        path: '',
        name: 'guideView',
        component: () => import('@/views/subpage/guide/guideView.vue'),
        meta: {
          title: '维权资讯'
        }
      },
      {
        path: 'guideDetail',
        name: 'guideDetail',
        component: () => import('@/views/subpage/guide/guideDetail.vue'),
        meta: {
          title: '维权资讯详情'
        }
      },
    ]
  },

  {
    path: '/dzht',
    name: 'dzht',
    component: () => import('@/views/subpage/dzht/index.vue'),
    meta: {
      title: '电子合同'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/route/index.vue'),
    redirect: '/about',
    meta: {
      title: '关于我们'
    },
    children: [{
      path: '/',
      name: 'aboutView',
      component: () => import('@/views/subpage/about/AboutView.vue'),
      meta: {
        title: '关于我们'
      }
    }]
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/route/index.vue'),
    redirect: '/help',
    meta: {
      title: '信息公开'
    },
    children: [{
        path: '/',
        name: 'helpView',
        component: () => import('@/views/subpage/help/helpView.vue'),
        meta: {
          title: '信息公开'
        }
      },
      {
        path: 'hxdwDetail',
        name: 'hxdwDetail',
        component: () => import('@/views/subpage/hxdwDetail/index.vue'),
        meta: {
          title: '详情'
        }
      },
    ]
  },
  {
    path: '/system',
    name: 'system',
    component: () => import('@/views/route/index.vue'),
    redirect: '/system',
    meta: {
      title: '管理入口'
    },
    children: [{
      path: '/',
      name: 'systemView',
      component: () => import('@/views/subpage/system/index.vue'),
      meta: {
        title: '管理入口'
      }
    }]
  },
  {
    path: '/oldHome',
    name: 'oldHome',
    component: () => import('@/views/route/index.vue'),
    redirect: '/oldHome',
    meta: {
      title: '旧版首页'
    },
    children: [{
      path: '/',
      name: 'oldHomeView',
      component: () => import('@/views/components/content2.vue'),
      meta: {
        title: '旧版首页'
      }
    }]
  },
  {
    path: '/internet',
    name: 'internet',
    component: () => import('@/views/route/index.vue'),
    redirect: '/internet',
    meta: {
      title: '互联网来源'
    },
    children: [{
      path: '/',
      name: 'internetView',
      component: () => import('@/views/subpage/internet/index.vue'),
      meta: {
        title: '互联网来源'
      }
    }]
  },
  {
    path: '/ajlr',
    name: 'ajlr',
    component: () => import('@/views/route/index.vue'),
    redirect: '/ajlr',
    meta: {
      title: '案件录入'
    },
    children: [{
      path: '/',
      name: 'ajlrView',
      component: () => import('@/views/subpage/ajlr/index.vue'),
      meta: {
        title: '案件录入'
      }
    }]
  },
  {
    path: '/complaintOne',
    name: 'complaintOne',
    component: () => import('@/views/subpage/tjts/complaintOne.vue'),
    meta: {
      title: '投诉须知'
    },
  },
  {
    path: '/complaintTwo',
    name: 'complaintTwo',
    component: () => import('@/views/subpage/tjts/complaintTwo.vue'),
    meta: {
      title: '投诉申请'
    },
  },

  {
    path: '/complaintThree',
    name: 'complaintThree',
    component: () => import('@/views/subpage/tjts/complaintThree.vue'),
    meta: {
      title: '案件查询'
    },
  },
  {
    path: '/zcNotice',
    name: 'zcNotice',
    component: () => import('@/views/subpage/wyzc/noticeView.vue'),
    meta: {
      title: '仲裁须知'
    },
  },
  {
    path: '/zcApplicant',
    name: 'zcApplicant',
    component: () => import('@/views/subpage/wyzc/applicantPage.vue'),
    meta: {
      title: '仲裁申请'
    },
  },
  {
    path: '/tjApplicant',
    name: 'tjApplicant',
    component: () => import('@/views/subpage/wytj/applicantPage.vue'),
    meta: {
      title: '调解申请'
    },
  },
  {
    path: '/applicantView',
    name: 'applicantView',
    component: () => import('@/views/subpage/wyzc/applicantView.vue'),
    meta: {
      title: '案件查询'
    },
  },
  {
    path: '/applicantView1',
    name: 'applicantView1',
    component: () => import('@/views/subpage/wytj/applicantView.vue'),
    meta: {
      title: '案件查询'
    },
  },
  {
    path: '/mapCommon',
    name: 'mapCommon',
    component: () => import('@/views/subpage/common/map.vue'),
    meta: {
      title: '地图'
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/route/index.vue'),
    redirect: '/home/detail',
    meta: {
      title: '指南'
    },
    children: [{
      path: 'detail',
      name: 'HomeDetail',
      component: () => import('@/views/components/homeCardDetail.vue'),
    }, ]
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/views/route/index.vue'),
    redirect: '/notice',
    meta: {
      title: '公示公告'
    },
    children: [{
        path: '/',
        name: 'noticeview',
        component: () => import('@/views/subpage/notice/list.vue'),
        meta: {
          title: '公示公告'
        },
      },
      {
        path: 'detail',
        name: 'noticeDetail',
        component: () => import('@/views/subpage/notice/detail.vue'),
        meta: {
          title: '详情'
        },
      },
      // {
      //   path: 'list',
      //   name: 'noticeList',
      //   component: () => import('@/views/subpage/notice/list.vue'),
      //   meta: {
      //     title: '更多内容'
      //   },
      // },
    ]
  },

  {
    path: '/tsCaseList',
    name: 'tsCaseList',
    component: () => import('@/views/subpage/caseList/tsList'),
    meta: {
      title: '投诉案件'
    },
  },

  {
    path: '/zczx',
    name: 'zczx',
    component: () => import('@/views/subpage/zczx/index'),
    meta: {
      title: '维权咨询'
    },
  },
  {
    path: '/zcCaseList',
    name: 'zcCaseList',
    component: () => import('@/views/subpage/caseList/zcList'),
    meta: {
      title: '仲裁案件'
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/subpage/login/loginPage.vue'),
    // redirect: '/login',
    meta: {
      title: '登录'
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/subpage/register/registerPage.vue'),
    // redirect: '/login',
    meta: {
      title: '注册'
    },
  },
  {
    path: '/loginHome',
    name: 'loginHome',
    component: () => import('@/views/subpage/loginHome/loginHome.vue'),
    // redirect: '/login',
    meta: {
      title: '首页'
    },
  },
  {
    path: '/loginHomeqy',
    name: 'loginHomeqy',
    component: () => import('@/views/subpage/loginHome/loginHomeqy.vue'),
    // redirect: '/login',
    meta: {
      title: '首页'
    },
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/subpage/forgetPassword/forgetPassword.vue'),
    // redirect: '/login',
    meta: {
      title: '忘记密码'
    },
  },
  {
    path: '/userProfile',
    name: 'userProfile',
    component: () => import('@/views/subpage/userProfile/userProfile.vue'),
    // redirect: '/login',
    meta: {
      title: '个人中心'
    },
  },
  {
    path: '/trail',
    name: 'trail',
    component: () => import('@/views/subpage/trail/index.vue'),
    // redirect: '/login',
    meta: {
      title: '互联网庭审'
    },
  },
  {
    path: '/meeting',
    name: '/meeting',
    component: () => import('@/views/subpage/meeting/index.vue'),
    // redirect: '/login',
    meta: {
      title: '庭审'
    },
  },
  {
    path: '/switchTelephone',
    name: 'switchTelephone',
    component: () => import('@/views/subpage/switchTelephone/switchTelephone.vue'),
    // redirect: '/login',
    meta: {
      title: '更换手机号'
    },
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: () => import('@/views/subpage/changePassword/changePassword.vue'),
    // redirect: '/login',
    meta: {
      title: '修改密码'
    },
  },
  {
    path: '/empty',
    name: 'empty',
    component: () => import('@/views/subpage/empty/empty.vue'),
    // redirect: '/login',
    meta: {
      title: '空白'
    },
  },
  {
    path: '/bookList',
    name: 'bookList',
    component: () => import('@/views/subpage/bookList/bookList.vue'),
    // redirect: '/login',
    meta: {
      title: '文书列表'
    },
  },
  {
    path: '/zlgl',
    name: 'Zlgl',
    component: () => import('@/views/route/index.vue'),
    redirect: '/zlgl',
    meta: {
      title: '资料管理'
    },
    children: [{
        path: '',
        name: 'ZlView',
        component: () => import('@/components/zlkView/index.vue'),
        meta: {
          title: '资料管理'
        }
      },
      {
        path: 'detail',
        name: 'ZlView',
        component: () => import('@/components/zlkView/detail.vue'),
        meta: {
          title: '资料管理'
        }
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  routes
})

// 在路由钩子中设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' - ' + setting.title
  } else {
    document.title = setting.title
  }
  NProgress.start() // 开始进度条
  next()
})

router.afterEach(() => {
  NProgress.done() // 结束进度条
})


export default router
